import { FocusShallow } from './tags/tags.model';

// TODO abstract as a unified function
export function focusesMatch(a: FocusShallow, b: FocusShallow): boolean {
    return (
        a &&
        b &&
        b.behaviourId != null &&
        a.behaviourId != null &&
        b.behaviourId === a.behaviourId &&
        b.subBehaviourId === a.subBehaviourId
    );
}
